import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "@/i18n/resources";
import type { Lang } from "@/i18n/languages";
import { DEFAULT_LANG } from "@/i18n/languages";

let initPromise: Promise<i18n.i18n> | null = null;

export async function initI18n(initialLang: Lang): Promise<i18n.i18n> {
  if (i18n.isInitialized) return i18n;

  if (!initPromise) {
    initPromise = i18n.use(initReactI18next).init({
      resources,
      lng: initialLang,
      fallbackLng: DEFAULT_LANG,
      ns: [
        "navigation",
        "footer",
        "home",
        "implantology",
        "endodontics",
        "oral-surgery",
        "periodontology",
        "orthodontics",
        "bonding",
        "prosthetics",
        "lip-filler",
        "cariesology",
        "teeth-whitening",
        "dental-tourism",
        "prices",
        "request-quote",
        "privacy-policy",
        "terms-of-service",
        "not-found",
        "seo",
      ],
      defaultNS: "navigation",
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
    });
  }

  return initPromise;
}
